import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectPopup from "./SelectPopup";
import { useMutation, useQuery } from "react-query";
import { ordersData } from "../globalApi/Api";
import docImage from "../../assests/document.png";
import * as XLSX from "xlsx";
import { productData } from "../globalApi/Api";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import axios from "axios";

const PopupModel = ({
  isOpen,
  closePopup,
  popupType,
  handleDelete,
  message,
  deleteLoading,
  setPopupType,
  navigateUrl,
  updateUrl,
  updatemessage,
  proformaData,
  state,
  type,
  filteredDetails,
  allRowIds,
  executiveNameRoute,
  selectedRows,
  excutiveName,
  incentiveDetails,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    reset,
  } = useForm();
  const navigate = useNavigate();
  const [selectPopup, setSelectPopup] = useState(false);
  const [selectState, setSelectState] = useState();

  const popupTypesToShow = [
    "add order",
    "add product",
    "add purchase",
    "add customer",
    "add executive",
  ];

  const showPopup = popupTypesToShow.includes(popupType?.type);

 

  // console.log("incentive data", incentiveDetails)

  // GET API START
  const { data, isLoading, isError, refetch } = useQuery(
    "ordersData",
    ordersData,
    {
      refetchOnWindowFocus: false,
    }
  );

  // GET API START
  const { data: productDetails } = useQuery("productData", productData, {
    refetchOnWindowFocus: false,
  });

  let details = (data && data?.data) || [];

  let totalProducts = (productDetails && productDetails?.data) || [];

  const [productSalesData, setProductSalesData] = useState([]);
  const [incentives, setIncentives] = useState([]);

  useEffect(() => {
    const safeIncentiveDetails = incentiveDetails ?? [];
    const safeProductDetails = productDetails?.data ?? [];
  
    // ---------- EDIT MODE ----------
    if (
      incentiveDetails &&
      Array.isArray(incentiveDetails?.incentiveDetails) &&
      incentiveDetails?.incentiveDetails?.length
    ) {
      const rows = incentiveDetails?.incentiveDetails?.map((r) => ({
        productName: r?.productName ?? "N/A",
        hsnCode: r?.hsnCode ?? "N/A",
        availableQuantity: r?.availableQty ?? 0,
        totalSoldQuantity: r?.soldQty ?? 0,
        totalSoldAmount: r?.soldPrice ?? 0,
      }));
  
      setProductSalesData(rows);
  
      setIncentives(
        incentiveDetails?.incentiveDetails?.map((r) => ({
          percentage: r?.incentivePercentage ?? "",
          amount: r?.incentiveAmount ?? 0,
        }))
      );
  
      reset({
        executiveName: incentiveDetails?.executiveName ?? "",
        incentiveDate: incentiveDetails?.incentiveDate
          ? new Date(incentiveDetails.incentiveDate)
          : new Date(),
        totalIncentive: incentiveDetails?.totalIncentive ?? 0,
      });
  
      return;
    }
  
    // ---------- CREATE MODE ----------
    if (!Array.isArray(safeIncentiveDetails) || !Array.isArray(safeProductDetails)) {
      setProductSalesData([]);
      setIncentives([]);
      return;
    }
  
    const salesMap = {};
  
    safeIncentiveDetails?.forEach((order) => {
      if (!Array.isArray(order?.orderProducts)) return;
  
      order.orderProducts.forEach((prod) => {
        const name = prod?.product?.trim();
        const qty = Number(prod?.quantity || 0);
        const up = Number(prod?.unitPrice || 0);
  
        if (!name) return;
  
        if (!salesMap[name]) {
          salesMap[name] = { totalSoldQuantity: 0, totalSoldAmount: 0 };
        }
  
        salesMap[name].totalSoldQuantity += qty;
        salesMap[name].totalSoldAmount += qty * up;
      });
    });
  
    const rows = Object.entries(salesMap).map(
      ([productName, { totalSoldQuantity, totalSoldAmount }]) => {
        const p = safeProductDetails?.find(
          (x) => x?.productNameEnglish?.trim() === productName
        );
  
        return {
          productName,
          totalSoldQuantity,
          totalSoldAmount,
          availableQuantity: p?.quantity ?? "N/A",
          hsnCode: p?.hsnCode ?? "N/A",
          unitPrice: p?.unitPrice ?? "N/A",
          gstAmount: p?.gstAmount ?? "N/A",
        };
      }
    );
  
    setProductSalesData(rows);
    setIncentives(rows.map(() => ({ percentage: "", amount: 0 })));
  
    reset({
      executiveName: excutiveName ?? "",
      incentiveDate: new Date(),
      totalIncentive: 0,
    });
  }, [incentiveDetails, productDetails, excutiveName, reset]);
  

  /* -------------------------------------------------------------
   * Derived values & handlers
   * ----------------------------------------------------------- */
  const handleIncentiveChange = (idx, percentage) => {
    setIncentives((prev) => {
      const next = [...prev];
      const sold = productSalesData[idx]?.totalSoldAmount || 0;
      const amount = ((percentage || 0) * sold) / 100;

      next[idx] = { percentage, amount };
      return next;
    });
  };

  const totalIncentiveAmount = incentives.reduce(
    (sum, row) => sum + (row.amount || 0),
    0
  );

  // Download Excel
  const downloadExcel = () => {
    // Define headers
    const headers = [
      "ORDER ID",
      "CUSTOMER NAME",
      "EXECUTIVE NAME",
      "ADDRESS",
      "LINE ROUTE",
      "ORDERED DATE",
      "DELIVERED STATUS",
    ];

    // If specific rows were selected in the parent, export only those.
    const sourceData =
      Array.isArray(getValues("selectedRows")) && getValues("selectedRows")?.length > 0
        ? filteredDetails?.filter((d) => getValues("selectedRows").includes(d?.id))
        : // fallback to `selectedRows` prop passed directly
          (typeof selectedRows !== "undefined" && selectedRows?.length > 0
          ? filteredDetails?.filter((d) => selectedRows.includes(d?.id))
          : filteredDetails);

    // Map data to match the headers order
    const formattedData =
      sourceData &&
      sourceData?.map((item, index) => ({
        "ORDER ID": item?.orderId || "",
        "CUSTOMER NAME": item?.customerName || "",
        "EXECUTIVE NAME": item?.executiveName || "",
        ADDRESS: item?.customerAddress || "",
        "LINE ROUTE": item?.lineroute || "",
        "ORDERED DATE": item?.salesDate || "",
        "DELIVERED STATUS": item?.deliveryStatus || "",
      }));

    // Create a new workbook and a worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "Over All.xlsx");
  };

  // SETVALUE FOR STATE VALUES

  useEffect(() => {
    setValue("executiveName", incentiveDetails?.executiveName);
    setValue("incentiveDate", incentiveDetails?.incentiveDate);
    setValue("totalIncentive", incentiveDetails?.totalIncentive);
  }, [incentiveDetails, setValue]);

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/incentives`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        alert("Incentive added successfullyy..");
        navigate("/incentiveView");
        closePopup();
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add Incentive. Please try again.");
      },
    }
  );
  //POST API END

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/incentives/${incentiveDetails?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        alert("Incentive Updated Successfully..");
        navigate("/incentiveView");
        window.location.reload();
        closePopup();
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the Orders. Please try again.");
      },
    }
  );

  let id = incentiveDetails?.id;
  // FORM START
  const onSubmit = (data) => {
    const incentiveDetails = productSalesData?.map((product, index) => ({
      incentivePercentage: Number(incentives[index]?.percentage || 0),
      incentiveAmount: Number(incentives[index]?.amount || 0),
      productName: product?.productName,
      hsnCode: product?.hsnCode,
      availableQty: product?.availableQuantity,
      soldQty: product?.totalSoldQuantity,
      soldPrice: product?.totalSoldAmount,
    }));

    const totalIncentive = incentiveDetails?.reduce(
      (sum, item) => sum + item?.incentiveAmount,
      0
    );

    const formData = {
      executiveName: excutiveName || data?.executiveName,
      incentiveDate: data?.incentiveDate,
      totalIncentive,
      incentiveDetails,
    };

    console.log("ssid", incentiveDetails?.id);
    if (id) {
      updateApi(formData);
    } else {
      mutate(formData);
    }
  };

  // FORM END

  if (!isOpen) return null;
  return (
    <>
      {popupType?.type == "confirm delete" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
              }}
            >
              <div
                style={{ borderBottom: "1px solid #000000" }}
                className="d-flex justify-content-between align-items-center"
              >
                <h6>
                  <b>Alert</b>
                </h6>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="close-btn"
                >
                  X
                </button>
              </div>
              <h5 className="delete-popup-message my-3">{message}</h5>
              <div className="d-flex justify-content-center gap-4 align-items-center">
                <button
                  onClick={() => {
                    handleDelete();
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  {deleteLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>YES</>
                  )}
                </button>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {popupType?.type == "delete success" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
              }}
            >
              <div
                style={{ borderBottom: "1px solid #000000" }}
                className="d-flex justify-content-between align-items-center"
              >
                <h6>
                  <b>Alert</b>
                </h6>
                <button
                  onClick={() => {
                    closePopup();
                  }}
                  className="close-btn"
                >
                  X
                </button>
              </div>
              <h5 className="delete-popup-message my-3">
                Deleted Successfully
              </h5>
              <div className="d-flex justify-content-center gap-4 align-items-center">
                <button
                  onClick={() => {
                    closePopup();
                    setPopupType({
                      ...popupType,
                      type: "",
                      data: "",
                    });
                  }}
                  className="popup_ok_cancel_btn my-2"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup" onClick={(e) => e.stopPropagation()}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ borderBottom: "1px solid #000000" }}
            >
              <h6>
                <b>Alert</b>
              </h6>
              <button onClick={closePopup} className="close-btn">
                X
              </button>
            </div>
            <h5 className="delete-popup-message my-3">
              {state ? updatemessage : message}
            </h5>
            <div className="d-flex justify-content-center gap-4 align-items-center">
              <button
                onClick={() => {
                  navigate(navigateUrl);
                  closePopup();
                }}
                className="popup_ok_cancel_btn my-2"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {type == "select report" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{
                height: "auto",
                width: "auto",
              }}
            >
              <div className="d-flex flex-column flex-md-row gap-3 align-items-center my-4 justify-content-center py-3">
                <div onClick={downloadExcel} className="report_doc_block">
                  <div className="doc_image_block">
                    <img
                      src={docImage}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <button type="button" className="report_generate_btn">
                    Over All Report
                  </button>
                </div>
                <div
                  className="report_doc_block"
                  onClick={() => {
                      navigate("/overallBillReport", {
                        state: {
                          filteredDetails,
                          executiveNameRoute,
                          selectedRows, // pass currently selected row ids so download can use them
                        },
                      });
                    }}
                >
                  <div className="doc_image_block">
                    <img
                      src={docImage}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <button type="button" className="report_generate_btn">
                    Over All Bill Report
                  </button>
                </div>
                <div
                  onClick={() => {
                    setSelectPopup(true);
                    setSelectState("route out");
                  }}
                  className="report_doc_block"
                >
                  <div className="doc_image_block">
                    <img
                      src={docImage}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <button type="button" className="report_generate_btn">
                    Order Report Route Wise
                  </button>
                </div>

                <div
                  onClick={() => {
                    setSelectPopup(true);
                    setSelectState("product out");
                  }}
                  className="report_doc_block"
                >
                  <div className="doc_image_block">
                    <img
                      src={docImage}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <button type="button" className="report_generate_btn">
                    Product Out Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <SelectPopup
        isOpen={selectPopup}
        closePopup={() => {
          setSelectPopup(false);
        }}
        type={selectState}
      />

      {type == "Incentive" && (
        <>
          <div className="popup-overlay" onClick={closePopup}>
            <div
              className="popup"
              onClick={(e) => e.stopPropagation()}
              style={{ borderRadius: "10px", width: "80%", height: "80%" }}
            >
              <h5 className="order-details-heading">ORDERS DETAILS</h5>

              {/* <h5 className="order-details-heading my-4">INCENTIVE DETAILS</h5> */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <table border="1" cellPadding="5" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th
                        colSpan="4"
                        style={{
                          border: "1px solid black",
                          textTransform: "uppercase",
                        }}
                      >
                        Executive Name :
                        <input
                          name="executiveName"
                          type="text"
                          className="form-control"
                          value={
                            excutiveName || incentiveDetails?.executiveName
                          } // from props or state
                          readOnly
                        />
                      </th>
                      <th
                        colSpan="4"
                        style={{
                          border: "1px solid black",
                          textTransform: "uppercase",
                        }}
                      >
                        <Controller
                          control={control}
                          name="incentiveDate"
                          defaultValue={new Date()}
                          render={({ field }) => (
                            <div className="mb-2">
                              <label className="form-label">
                                Incentive Date :{" "}
                              </label>
                              <DatePicker
                                className="form-control"
                                placeholderText="Select Incentive Date"
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                dateFormat="yyyy-MM-dd"
                              />
                            </div>
                          )}
                        />
                      </th>
                    </tr>
                    <tr>
                      <th>S.No</th>
                      <th>Product Name</th>
                      <th>HSN Code</th>
                      <th>Available Qty</th>
                      <th>Total Sold Qty</th>
                      <th>Sold Price</th>
                      <th>Percentage</th>
                      <th>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productSalesData?.map((item, index) => (
                      <tr key={item?.productName + index}>
                        <td className="product-item">{index + 1}</td>
                        <td className="product-item">{item?.productName}</td>
                        <td className="product-item">{item?.hsnCode}</td>
                        <td className="product-item">
                          {item?.availableQuantity}
                        </td>
                        <td className="product-item">
                          {item?.totalSoldQuantity}
                        </td>
                        <td className="product-item">
                          {item?.totalSoldAmount?.toFixed(2)}
                        </td>
                        <td className="product-item">
                          <input
                            type="number"
                            placeholder="Percentage"
                            className="incentive_input_field"
                            value={incentives[index]?.percentage}
                            onChange={(e) =>
                              handleIncentiveChange(
                                index,
                                parseFloat(e.target.value || 0)
                              )
                            }
                          />
                        </td>
                        <td className="product-item">
                          <input
                            type="number"
                            readOnly
                            className="incentive_input_field"
                            value={incentives[index]?.amount.toFixed(2)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        colSpan="7"
                        className="product-item"
                        style={{ border: "1px solid black", textAlign: "end" }}
                      >
                        <b> TOTAL INCENTIVE</b>
                      </td>
                      <td style={{ border: "1px solid black" }}>
                        <Controller
                          name="totalIncentive"
                          control={control}
                          defaultValue={totalIncentiveAmount.toFixed(2)}
                          render={({ field }) => (
                            <input
                              {...field}
                              type="number"
                              step="any"
                              className="form-control"
                              value={
                                totalIncentiveAmount.toFixed(2) ||
                                incentiveDetails?.totalIncentive
                              }
                              readOnly
                            />
                          )}
                        />
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <button className="mt-4 mb-2 incentive_save_btn">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>SAVE</>
                  )}
                </button>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PopupModel;
